"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSource = void 0;
/** @TranslateToPython */
var DataSource;
(function (DataSource) {
    DataSource["PYTHON_DATA_REPORT"] = "PYTHON_DATA_REPORT";
    DataSource["LOAN_APPLICATION_QUALIFICATION_RATIONAL"] = "LOAN_APPLICATION_QUALIFICATION_RATIONAL";
    DataSource["LOAN_APPLICATION_OVERRIDES"] = "LOAN_APPLICATION_OVERRIDES";
    DataSource["OFFER_TERMS_BEFORE_MANUAL_EDITS"] = "OFFER_TERMS_BEFORE_MANUAL_EDITS";
    DataSource["BACK_FILL"] = "BACK_FILL";
    DataSource["LOG"] = "LOG";
})(DataSource || (exports.DataSource = DataSource = {}));
